import { PropsWithChildren, ReactNode } from "react";

import { Header } from "./header";
import { Container } from "semantic-ui-react";
import { Outlet } from "react-router";
import { marginTop } from "styled-system";

export const Layout: React.FC<PropsWithChildren<ReactNode>> = ({
  children,
}) => {
  return (
    <Container fluid>
      <Header />
      <Container style={{ marginTop: "5rem" }}>
        <Outlet />
      </Container>
    </Container>
  );
};
